// extracted by mini-css-extract-plugin
export default {"input":"_inputs_input__189iO","betAmtInputWrapper":"_inputs_betAmtInputWrapper__p3hGI","label":"_inputs_label__hPBQa","suffix":"_inputs_suffix__E5rxs"};